import React, { useEffect, useRef, useState } from 'react';
import './registry.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';
import fileDownload from 'js-file-download';
import moment from 'moment';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';
import * as ReactDOM from 'react-dom';
import {
  calculatedViewMode, getFilterData,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import {
  annulmentVehicles,
  archiveVehicles,
  deleteVehicles,
  exportVehicles,
  importVehicles,
  loadVehiclesById,
  loadVehiclesList,
  sendVehiclesFgisTaxi,
  unarchiveVehicles,
  extractVehiciesById,
  loadVehicleFieldsValidation,
  exportOsago,
  importOsago,
  restoreVehicles, loadVehicleIdList,
  vehicleRegistryBatchCommand, loadCarrierIdList,
} from '../actions';
import { getSystemData } from '../../System/reducer';
import { getRegisterData } from '../reducer';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import ApplicationsDTO from '../../../dto/ApplicationsDTO';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import VehiclesForm from './VehiclesForm';
import VehiclesView from './VehiclesView';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import {
  REGISTRIES_TYPE,
  REGISTRIES_VEHICLE_STATUS_LIST,
  REGISTRY_STATUS, TYPE_ROLLBACK_ENUM, USER_COMMAND_NAMES,
} from '../../../configs';
import {
  showGlobalConfirm,
  showSignPopup,
} from '../../System/actions';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import RegistryImport from './RegistryImport';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import { additionalVehicleColumns, vehicleColumns } from './vehiclesColumns';
import AnnulmentReasonDialog from './AnnulmentReasonDialog';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import ViewDocument from '../../System/components/ViewDocument';
import { REGION_REGISTRY_MODULE } from '../../../configs/moduleNames';
import DropdownList from '../../../components/base/Dropdown/DropdownList';
import getDefaultSort from '../../../utils/getDefaultSort';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import { VersionListDialog } from '../../RollbackVersion/components/VersionListDialog';
import { RollbackPlanDialog } from '../../RollbackVersion/components/RollbackPlanDialog';
import { getRollbackVersionData } from '../../RollbackVersion/reducer';
import { createRollbackPlans } from '../../RollbackVersion/actions';
import CheckBoxInput from '../../../components/fields/CheckBoxInput/CheckBoxInput';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import MobileApplicationHistoryFooter from '../../Application/components/MobileApplicationHistoryFooter';
import MobileVehiclesView from './MobileVehiclesView';
import PropertyGrid from '../../../components/base/Grid/PropertyGrid';
import ExportInterface from '../../System/components/ExportInterface';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function VehiclesRegistryPage() {
  const blockRef = useRef(null);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [showExtract, setShowExtract] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [showImportOsago, setShowImportOsago] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selected, setSelected] = useState([]);
  const [isAllPageRowsSelected, setIsAllPageRowsSelected] = useState(false);
  const [showAnnulment, setShowAnnulment] = useState(false);
  const { updatePeriod } = useSelector(getSystemData);
  const [searchParams, setSearchParams] = useSearchParams();
  const automation_rule_id = searchParams.get('automation_rule_id');
  const [showHistoryVersion, setShowHistoryVersion] = useState(false);
  const [showRollbackPlan, setShowRollbackPlan] = useState(false);
  const isNew = searchParams.get('new');
  const isExport = searchParams.get('export');
  const isImport = searchParams.get('import');
  const registry_id = searchParams.get('registry_id');
  const block_180_days = searchParams.get('block_180_days');
  const numbersText = searchParams.get('numbers') || '';
  const [prevProcedures, sePrevProcedures] = useState(block_180_days);
  const numbers = numbersText.split(',') || [];
  const today = moment().startOf('day').format('YYYY.MM.DD');
  const {
    loadingVehiclesList,
    vehiclesList = [],
    vehiclesListMeta = {},
    currentVehicles = {},
    vehicleExtractList = {},
    loadingVehicleExtractList = false,
    loadingCurrentVehicles = false,
    loadingEditVehicles = false,
    loadingArchiveVehicles = false,
    loadingUnarchiveVehicles = false,
    loadingDeleteVehicles = false,
    loadingAnnulmentVehicles = false,
    loadingImportVehicles = false,
    loadingExportVehicles = false,
    vehicleFieldsValidation = {},
    loadingVehicleFieldsValidation = false,
    loadingVehicleRegistryBatchCommand = false,
  } = useSelector(getRegisterData);

  const {
    rollbackPlan,
  } = useSelector(getRollbackVersionData);

  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    created_at: [defaultDate[0], defaultDate[1]],
    view_mode: 2,
    number: numbers,
  };
  const filterName = 'vehicle-filter';
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({
    defaultValues: defaultFilterValues,
    resetOptions: {
      keepValues: false,
      keepDirtyValues: false,
      keepDefaultValues: false,
    },
  });

  const loadRegistry = () => {
    if (registry_id) {
      dispatch(loadVehiclesById(registry_id))
        .then(() => {
          setShowView(true);
          dispatch(loadVehicleFieldsValidation({ id: registry_id })).catch(responseLogWithNotification);
        })
        .catch(response => errorNotification('Загрузка реестровых данных', getResponseError(response)));
    }
  };
  const loadData = opts => {
    const filterData = getValues();
    const viewModeData = calculatedViewMode(filterData.view_mode);
    delete filterData.view_mode;
    const paginationOpts = getPaginationOpts(store.getState()[REGION_REGISTRY_MODULE].vehiclesListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const unresolved_alerts = {
      automation_rule_id,
    };
    const requestData = {
      ...paginationOpts,
      filter: { ...filterData, ...viewModeData, unresolved_alerts },
      sort,
    };
    const p1 = dispatch(loadVehiclesList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [sort, setSort] = useState(getDefaultSort(vehicleColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => reset(getFilterData(filterName, defaultFilterValues)), []);
  useEffect(() => setShowForm(!!isNew), [isNew]);
  const [isBatchCommand, setIsBatchCommand] = useState(false);
  useEffect(() => setShowExport(!!isExport), [isExport]);
  useEffect(() => setShowImport(!!isImport), [isImport]);
  useEffect(loadRegistry, [registry_id]);
  useEffect(() => {
    const subscription = watch(values => {
      loadData({ page: 1 });
      localStorage.setItem(filterName, JSON.stringify(values));
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (isAllPageRowsSelected && isBatchCommand) {
      dispatch(loadVehicleIdList({
        filter: getValues(),
      })).then(data => {
        setSelected(data?.data);
      }).catch(responseLogWithNotification);
    }
  }, [isAllPageRowsSelected, isBatchCommand]);

  useEffect(() => {
    setValue('is_locked', !!block_180_days || null);
    if (prevProcedures !== block_180_days) {
      sePrevProcedures(block_180_days);
    }
  }, [block_180_days]);

  const handleSetUrlParams = params => {
    const result = Object.keys(params).reduce((acc, c) => {
      if (params[c]) {
        acc[c] = params[c];
      }
      return acc;
    }, {});
    setSearchParams(result);
  };

  const DTO = new ApplicationsDTO();
  const attributes = DTO.getAttributesByName();

  const batchCommand = (items, key = 'Не задан') => values => {
    handleClose();
    dispatch(vehicleRegistryBatchCommand({
      items, key, values,
    })).then(() => loadData()).catch(responseLogWithNotification);
  };

  const handleEdit = item => event => {
    if (!item) {
      return;
    }
    dispatch(loadVehiclesById(item.id))
      .then(() => {
        dispatch(loadVehicleFieldsValidation({ id: item.id })).catch(responseLogWithNotification);
        setShowForm(true);
        setIsEdit(true);
      })
      .catch(response => errorNotification('Экспорт легкового такси', getResponseError(response)));
  };

  const handleImport = files => {
    if (!files) {
      return;
    }
    const data = new FormData();
    for (let i = 0, len = files.length; i < len; i++) {
      const file = files[i];
      data.append('file', file);
    }
    dispatch(importVehicles(data))
      .then(() => successNotification('Импорт реестра', 'Процесс импорта прошел успешно'))
      .catch(response => errorNotification('Импорт легкового такси', getResponseError(response)));
    handleClose();
  };

  const handleImportOsago = files => {
    if (!files) {
      return;
    }
    const data = new FormData();
    for (let i = 0, len = files.length; i < len; i++) {
      const file = files[i];
      data.append('file', file);
    }
    dispatch(importOsago(data))
      .then(() => successNotification('Обработка файлов ответа', 'Процесс обработки файлов ответа прошел успешно'))
      .catch(response => errorNotification('Импорт легкового такси', getResponseError(response)));
    handleClose();
  };

  const handleExport = (format, columns) => {
    dispatch(exportVehicles({ ...getValues(), format, columns }))
      .then(data => {
        if (data) { fileDownload(data, `Реестр легковых такси.${format}`); }
      })
      .catch(response => errorNotification('Загрузка карточки легкового такси', getResponseError(response)));
    handleClose();
  };

  const handleExportOsago = () => {
    dispatch(exportOsago()).then(data => {
      if (data) { fileDownload(data, `${today}-Реестр_ЛТ.csv`); }
    }).catch(response => errorNotification('Загрузка файлов ответа', getResponseError(response)));
  };

  const handleExtract = item => event => {
    if (!item) {
      return;
    }
    dispatch(extractVehiciesById({ id: item.id }))
      .then(() => {
        successNotification('Выписка', 'Выписка прошла успешно');
      })
      .catch(response => errorNotification('Выписка', getResponseError(response)));
    setShowExtract(true);
    setSelectedRow(item);
  };

  const handleAnnulment = (item, isBach = false) => event => {
    if (!isBach && !item) {
      return;
    }
    if (!isBach && item) {
      setSelectedRow(item);
    } else {
      setIsBatchCommand(isBach);
    }
    setShowAnnulment(true);
  };

  const annulment = values => {
    if (!selectedRow) {
      return;
    }
    dispatch(annulmentVehicles({ id: selectedRow.id, values }))
      .then(() => {
        successNotification('Исключение реестровой записи', 'Сформировано Решение об исключении');
        handleClose();
        loadData();
      })
      .catch(response => errorNotification('Исключение реестровой записи', getResponseError(response)));
  };

  const handleArchive = (item, isBach = false, isUnarchive = false) => () => {
    if (!isBach && !item) {
      return;
    }
    const action = item?.archived_at || isUnarchive ? unarchiveVehicles : archiveVehicles;
    const key = isUnarchive ? USER_COMMAND_NAMES.IN_ARCHIVED : USER_COMMAND_NAMES.ARCHIVED;

    if (!isBach && item) {
      const title = item?.archived_at ? 'Извлечение из архива' : 'Перемещение в архив';
      dispatch(action(item.id))
        .then(() => {
          loadData();
          successNotification(title, 'Процесс прошел успешно');
        })
        .catch(response => errorNotification(title, getResponseError(response)));
    } else {
      if (isAllPageRowsSelected) {
        dispatch(loadVehicleIdList({
          filter: getValues(),
        })).then(data => {
          setSelected(data?.data);
          batchCommand(action, data?.data, key)();
        }).catch(responseLogWithNotification);
        return;
      }
      batchCommand(selected, key)();
    }
  };

  const handleDeleteAndRestore = item => () => {
    if (!item) {
      return;
    }
    const action = !item.deleted_at ? deleteVehicles : restoreVehicles;
    const title = !item.deleted_at ? 'Удаление карточки легкового такси' : 'Восстановление карточки легкового такси';
    dispatch(action(item.id))
      .then(() => {
        loadData();
        successNotification(title, 'Процесс прошел успешно');
      })
      .catch(response => errorNotification(title, getResponseError(response)));
  };

  const handleGroupRestore = () => {
    if (isAllPageRowsSelected) {
      dispatch(loadCarrierIdList({
        filter: getValues(),
      })).then(data => {
        setSelected(data?.data);
        batchCommand(data?.data, USER_COMMAND_NAMES.RESTORE)();
      }).catch(responseLogWithNotification);
      return;
    }
    batchCommand(selected, USER_COMMAND_NAMES.RESTORE)();
  };

  const handleDelete = (item, isBach = false) => event => {
    if (!isBach && !item) {
      return;
    }
    if (!isBach && item) {
      dispatch(showGlobalConfirm({
        confirmMessage: `Удаление карточки легкового такси №${item.number}`,
        confirmButtonText: 'Удалить',
        confirmClassName: 'remove-preset',
      })).then(() => {
        dispatch(deleteVehicles(item.id)).then(() => {
          loadData();
          successNotification('Удаление карточки легкового такси', 'Удаление прошло успешно');
        }).catch(response => {
          errorNotification('Удаление карточки легкового такси', getResponseError(response));
        });
      }).catch(() => {});
    } else {
      if (isAllPageRowsSelected) {
        dispatch(loadVehicleIdList({
          filter: getValues(),
        })).then(data => {
          setSelected(data?.data);
          batchCommand(data?.data, USER_COMMAND_NAMES.DELETED)();
        }).catch(responseLogWithNotification);
        return;
      }
      batchCommand(selected, USER_COMMAND_NAMES.DELETED)();
    }
  };

  const handleShow = item => event => {
    if (!item) {
      return;
    }
    handleSetUrlParams({ block_180_days, registry_id: item.id });
  };

  const handleClose = item => {
    setIsEdit(false);
    setShowForm(false);
    setShowImport(false);
    setShowImportOsago(false);
    setShowExport(false);
    setSearchParams({});
    setShowAnnulment(false);
    setShowExtract(false);
    setShowHistoryVersion(false);
    setShowRollbackPlan(false);
    setIsBatchCommand(false);
    setSelected([]);
    setSelectedRow(null);
    setIsAllPageRowsSelected(false);
    handleSetUrlParams({ block_180_days });
  };

  const handleShowHistoryVersion = item => () => {
    if (!item) {
      return;
    }
    setSelectedRow(item);
    setShowHistoryVersion(true);
  };

  const handleSendFgisTaxi = event => {
    dispatch(showSignPopup())
      .then(cert => {
        dispatch(sendVehiclesFgisTaxi({ cert }))
          .then(() => {
            loadData();
            successNotification('Отправка реестра в ФГИС Такси', 'Отправка прошла успешно');
          })
          .catch(responseLogWithNotification);
      }).catch(() => {});
  };

  const renderContextMenu = item => (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button" onClick={handleExtract(item)}>
        Выписка
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={handleShow(item)}>
        Просмотреть
      </Button>
      {item?.status !== REGISTRY_STATUS.ANNULMENT && !isMobile
        ? (
          <>
            <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
              Редактировать
            </Button>
            <Button variant="link" className="w-100 more-button" onClick={handleAnnulment(item)}>
              Исключить
            </Button>
          </>
        ) : null }
      {/* <Button variant="link" className="w-100 more-button" onClick={handleCreateStatement(item)}> */}
      {/*  Сформировать выписку */}
      {/* </Button> */}
      {!isMobile ? (
        <Button variant="link" className="w-100 more-button" onClick={handleArchive(item)}>
          {item?.archived_at ? 'Перевести в активный' : 'Перевести в архивный'}
        </Button>
      ) : null }
      {/* <Button variant="link" className="w-100 more-button delete" onClick={handleDelete(item)}> */}
      {/*  Удалить */}
      {/* </Button> */}
      {!isMobile ? (
        <Button variant="link" className="w-100 more-button" onClick={handleDeleteAndRestore(item)}>
          {!item?.deleted_at ? 'Перевести в удаленные' : 'Восстановить'}
        </Button>
      ) : null }
      <Button variant="link" className="w-100 more-button" onClick={handleShowHistoryVersion(item)}>
        История изменений
      </Button>
      {!isMobile ? (
        <Button variant="link" className="w-100 more-button" onClick={() => handleCreateRollbackPlan(item)}>
          Восстановить предыдущий статус
        </Button>
      ) : null }
    </div>
  );
  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    const ed = moment(item.expiration_date);
    const now = moment();
    if (ed.isValid() && now.diff(ed, 'days') >= 0) {
      classes.push('expiration');
    }
    if (item && item.archived_at) {
      classes.push('is_archive');
    }
    return classes.join(' ');
  };

  const handleCreateRollbackPlan = item => {
    if (!item) {
      return;
    }
    let root_models;
    if (Array.isArray(item)) {
      root_models = item?.map(id => ({
        root_model_type: 'vehicle',
        root_model_id: id,
      }));
    } else if (item?.version) {
      root_models = [{
        target_version: item?.version,
        root_model_type: 'vehicle',
        root_model_id: item?.subject_id || item?.id,
      }];
    } else {
      root_models = [{
        root_model_type: 'vehicle',
        root_model_id: item?.subject_id || item?.id,
      }];
    }

    dispatch(createRollbackPlans({ root_models })).then(() => setShowRollbackPlan(true)).catch(responseLogWithNotification);
    setShowHistoryVersion(false);
  };

  const handleRollbackPlanGroup = () => () => {
    if (!Array.isArray(selected) || !selected?.length) {
      return;
    }
    if (isAllPageRowsSelected) {
      dispatch(loadVehicleIdList({
        filter: getValues(),
      })).then(data => {
        setSelected(data?.data);
        handleCreateRollbackPlan(data?.data);
      }).catch(responseLogWithNotification);
    } else {
      handleCreateRollbackPlan(selected);
    }
  };

  const handleSelectCheckBox = (item, check) => e => {
    const newSelectedList = check ? selected.filter(e => e !== item.id) : [...selected, item.id];
    setSelected(newSelectedList);
    e.stopPropagation();
  };

  const checkBoxColumnFormatter = (_, item) => {
    const check = selected.includes(item.id);
    return (
      <div className="bordered-checkbox" onClick={handleSelectCheckBox(item, check)}>
        <CheckBoxInput
          inputProps={{
            value: check,
          }}
        />
      </div>
    );
  };

  const handleSelectHeaderCheckBox = e => {
    const idsPerPage = vehiclesList?.map(i => i.id);
    if (isAllPageRowsSelected) {
      setIsAllPageRowsSelected(!isAllPageRowsSelected);
      const newSelectedList = selected.filter(f => !idsPerPage.includes(f));
      setSelected(newSelectedList);
      return;
    }
    const isSelectAllOnPage = vehiclesList.every(i => selected.includes(i.id));
    if (isSelectAllOnPage) {
      setIsAllPageRowsSelected(!isAllPageRowsSelected);
      return;
    }
    setSelected([...selected, ...idsPerPage]);
    e.stopPropagation();
  };

  const checkBoxHeaderFormatter = () => {
    const idsPerPage = vehiclesList?.map(i => i.id);
    const isAllPerPage = vehiclesList.every(i => selected.includes(i.id));
    const isSome = (selected.some(i => !idsPerPage.includes(i)) || vehiclesList.some(i => selected.includes(i.id))) && !isAllPerPage;
    return (
      <div
        className="bordered-checkbox"
        onClick={handleSelectHeaderCheckBox}
      >
        <CheckBoxInput
          className={classNames({ 'some-child': isSome }, { 'all-child': isAllPageRowsSelected })}
          inputProps={{
            value: isAllPerPage,
          }}
        />
      </div>
    );
  };

  const columns = [
    !isMobile
      ? {
        dataField: 'checkBox',
        headerClassName: 'check-box text-center column-relative',
        dataClassName: 'align-middle column-relative text-center justify-content-center',
        formatter: checkBoxColumnFormatter,
        headerFormatter: checkBoxHeaderFormatter,
      } : null,
    ...vehicleColumns,
  ].filter(column => column);

  const renderFooter = () => {
    const element = document.getElementById('app-content-footer');
    if (!element) {
      return null;
    }
    return ReactDOM.createPortal(<MobileApplicationHistoryFooter
      control={control}
      defaultFilterValues={defaultFilterValues}
      getValues={getValues}
      reset={reset}
      page={PAGE_TYPE.PASSENGER_TAXI}
    />, element);
  };

  return (
    <div className="page application-page">
      <TimerLoader
        global
        loading={!loadingVehicleRegistryBatchCommand ? (
          loadingVehiclesList
        || loadingCurrentVehicles
        || loadingEditVehicles
        || loadingArchiveVehicles
        || loadingUnarchiveVehicles
        || loadingDeleteVehicles
        || loadingAnnulmentVehicles
        || loadingExportVehicles
        || loadingVehicleFieldsValidation
        ) : loadingVehiclesList}
      />
      <div className="page-title">
        <div className="title-text">
          {formatMessage({ id: `menu.region.registry.passenger.taxi.${block_180_days ? 'block_180_days' : 'full'}` })}
          {automation_rule_id ? ' (из уведомления)' : ''}
        </div>
        {!isMobile ? (
          <FilterRow>
            <FieldDTO
              control={control}
              component={TextSearchInput}
              dtoObject={{
                name: 'search',
                type: String,
                labelKey: 'search',
              }}
              className="no-border"
            />
            <FieldDTO
              control={control}
              component={CustomSelectInput}
              dtoObject={attributes.status}
              usePortal
              className="no-border"
              options={REGISTRIES_VEHICLE_STATUS_LIST}
              placeholder="Статус"
              addPlaceholder
            />
            <FieldDTO
              control={control}
              component={RangeDatePicker}
              dtoObject={attributes.created_at}
              usePortal
              placeholder="Дата"
              changeFormat="YYYY-MM-DD"
              className="no-border"
            />
            <DropdownList
              className="ml-3 ms-3 button-list second"
              label={(
                <>
                  <span className="load-button-label-text">Пакетная обработка</span>
                  <Icons className="load-icon-arrow" icon="arrow-down" customIcon />
                </>
              )}
              variant="second"
            >
              <Button variant="link" className="button-alternate menu-button grey-text" onClick={() => handleExportOsago()}>
                <Icons className="load-icon me-2" icon="download-registry" customIcon />
                Скачать файл запроса
              </Button>
              <Button variant="link" className="button-alternate menu-button grey-text" onClick={() => setShowImportOsago(true)}>
                <Icons className="load-icon me-2" icon="upload-registry" customIcon />
                Обработать файл ответа
              </Button>
              <Button
                variant="link"
                className="button-alternate menu-button grey-text"
                onClick={handleSendFgisTaxi}
              >
                <Icons customIcon className="file-download me-2" width={24} height={24} icon="download" />
                ФГИС Такси
              </Button>
              <Button
                variant="link"
                className="button-alternate menu-button grey-text"
                onClick={() => {
                  setShowExport(true);
                }}
              >
                <Icons customIcon className="file-download me-2" width={24} height={24} icon="download" />
                Экспорт реестра
              </Button>
              <Button
                variant="link"
                className="button-alternate menu-button grey-text"
                onClick={() => {
                  setShowImport(true);
                }}
              >
                <Icons customIcon className="file-download me-2" width={24} height={24} icon="upload" />
                Импорт реестра
              </Button>
              { Array.isArray(selected) && selected.length
                ? (
                  <>
                    <Button
                      variant="link"
                      className="button-alternate menu-button grey-text"
                      onClick={handleRollbackPlanGroup()}
                    >
                      Откат версий
                    </Button>
                    <Button
                      variant="link"
                      className="button-alternate menu-button grey-text"
                      onClick={handleAnnulment(null, true)}
                    >
                      Исключение
                    </Button>
                    <Button
                      variant="link"
                      className="button-alternate menu-button grey-text"
                      onClick={handleArchive(null, true)}
                    >
                      Перенос в архив
                    </Button>
                    <Button
                      variant="link"
                      className="button-alternate menu-button grey-text"
                      onClick={handleArchive(null, true, true)}
                    >
                      Перенос из архив
                    </Button>
                    <Button
                      variant="link"
                      className="button-alternate menu-button grey-text"
                      onClick={handleDelete(null, true)}
                    >
                      Удаление
                    </Button>
                    <Button
                      variant="link"
                      className="button-alternate menu-button grey-text"
                      onClick={handleGroupRestore}
                    >
                      Восстановить
                    </Button>
                  </>
                ) : null}
            </DropdownList>
            <div className="filter-sep" />
            <Button
              variant="second"
              className=""
              onClick={() => {
                setOpenFilter(true);
              }}
            ><Icons customIcon className="file-download" width={24} height={24} icon="filter" />
            </Button>
            <div className="filter-sep" />
            <Button variant="second" className="" onClick={() => setShowForm(true)}>
              <Icons
                customIcon
                className="file-download"
                width={24}
                height={24}
                icon="plus"
              />
            </Button>
            {isOpenFilter
              ? (
                <FilterModal
                  control={control}
                  onClose={() => setOpenFilter(false)}
                  getValues={getValues}
                  reset={reset}
                  defaultValues={defaultFilterValues}
                  page={PAGE_TYPE.PASSENGER_TAXI}
                />
              )
              : null}
          </FilterRow>
        ) : null}
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          {!isMobile ? (
            <div className="grid-wrapper frame">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <CustomizedGrid
                  rowClassFormatter={rowClassFormatter}
                  data={vehiclesList}
                  columns={columns}
                  changeSort={changeSort}
                  sort={sort}
                  onDoubleClickByRow={(item, event) => handleShow(item)(event)}
                  additionalColumns={additionalVehicleColumns}
                  name="vehicle-list"
                  settingsFormatter={moreFormatter}
                  renderContextMenu={renderContextMenu}
                />
              </div>
            </div>
          ) : (
            <PropertyGrid
              rowClassFormatter={rowClassFormatter}
              data={vehiclesList}
              columns={columns}
              changeSort={changeSort}
              sort={sort}
              onDoubleClickByRow={(item, event) => handleShow(item)(event)}
              additionalColumns={additionalVehicleColumns}
              name="vehicle-list"
              settingsFormatter={moreFormatter}
              renderContextMenu={renderContextMenu}
            />
          )}
          <Pagination meta={vehiclesListMeta} list={vehiclesList} handleChangeMeta={loadData} />
        </div>
      </div>
      {showForm && !isEdit ? <VehiclesForm onClose={handleClose} loadData={loadData} /> : null}
      {showForm && isEdit ? (
        <VehiclesForm
          key={currentVehicles && currentVehicles.id ? currentVehicles.id : ''}
          formMeta={vehicleFieldsValidation}
          data={currentVehicles}
          isEdit={isEdit}
          onClose={handleClose}
          loadData={loadData}
        />
      ) : null}
      {showView && currentVehicles && !isMobile ? <VehiclesView handleExtract={handleExtract} formMeta={vehicleFieldsValidation} handleEdit={handleEdit(currentVehicles)} onClose={() => { handleClose(); setShowView(false); }} loadData={loadData} /> : null}
      {showView && currentVehicles && isMobile ? <MobileVehiclesView formMeta={vehicleFieldsValidation} handleEdit={handleEdit(currentVehicles)} onClose={() => { handleClose(); setShowView(false); }} loadData={loadData} /> : null}
      {showExport ? (
        <ExportInterface
          page="vehicles"
          exporter="vehicles"
          getValues={getValues}
          onClose={handleClose}
          selected={selected}
        />
      ) : null}
      {showImport ? <RegistryImport onClose={handleClose} handleImport={handleImport} type="vehicle" /> : null}
      {showImportOsago ? <RegistryImport onClose={handleClose} title="Загрузка ответа от ОСАГО" handleImport={handleImportOsago} type="osago" /> : null}
      {showAnnulment ? <AnnulmentReasonDialog withoutValidation current={selectedRow} legal_entity_type={selectedRow?.legal_entity_type} typeRegistry={REGISTRIES_TYPE.VEHICLE} close={handleClose} send={isBatchCommand ? batchCommand(selected, USER_COMMAND_NAMES.ANNULMENT_VEHICLE) : annulment} /> : null}
      {showExtract && vehicleExtractList
        ? (
          <ViewDocument
            loadData={loadData}
            loadingVehicleExtractList={loadingVehicleExtractList}
            handleClose={handleClose}
            document={{ files: [vehicleExtractList] }}
            prevCrumbs={(
              <>
                <span className="breadcrumbs-prev">Реестры</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
                <span className="breadcrumbs-prev">Реестр ЛТ</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
              </>
          )}
          />
        ) : null}
      {selectedRow?.id && showHistoryVersion ? <VersionListDialog type={TYPE_ROLLBACK_ENUM.VEHICLE} id={selectedRow?.id} handleCreateRollbackPlan={handleCreateRollbackPlan} onClose={handleClose} /> : null}
      {rollbackPlan?.id && showRollbackPlan ? <RollbackPlanDialog rollbackPlanId={rollbackPlan?.id} onClose={handleClose} /> : null}
      {isMobile ? renderFooter() : null}
    </div>
  );
}
